export enum DirectionsServiceEnum {
  Google = "google",
  OSRM = "osrm",
  Mapbox = "Mapbox",
  Here = "here",
  Esri = "esri",
  TomTom = "tomtom",
}
